<template>
  <v-tabs
    class="nx-tabs"
    :class="classes"
    :value="selectedTab"
    v-bind="$attrs"
    @change="handleChange"
    ref="tabs"
  >
    <v-tab class="nx-tab" v-for="(tab, index) in tabs" :key="index">
      {{ tab.label }}
    </v-tab>
    <slot></slot>
  </v-tabs>
</template>

<script>
/**
 * Tabs component
 *
 * @property {Object[]}  tabs   Array of tabs. Each tab has an id and label property
 * @property {string}    value  (Optional) Initial selected tab
 *
 * @fires input The tab selected
 */
export default {
  name: 'nx-tabs',
  props: {
    value: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
    },
    /*
     * Example: [
     *  { id: 'article', label: 'Noticia' },
     *  { id: 'image', label: 'Imagen' },
     * ]
     */
    tabs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    classes() {
      return {
        disabled: this.disabled,
      };
    },
    selectedTab() {
      if (!this.value) return null;
      const index = this.tabs.findIndex(tab => tab.id === this.value);
      if (index === -1) return null;
      return index;
    },
  },
  methods: {
    handleChange(index) {
      if (!this.tabs[index]) {
        return;
      }
      this.$emit('input', this.tabs[index].id);
    },
  },
  mounted() {
    // Fix initial tabs slider width
    setTimeout(() => {
      if (this.$refs.tabs) {
        this.$refs.tabs.callSlider();
      }
    }, 300);
  },
};
</script>

<style lang="stylus">
@import '../assets/stylus/variables.styl'

.nx-tabs {
  &.disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .nx-tab {
    margin: 0 30px 16px 0;
    .v-tabs__item {
      font-size: 16px;
      font-weight: 500;
      color: black;
      opacity: 0.6;
      padding: 0;
      &--active {
        opacity: 1;
      }
    }
  }

  .theme--dark,
  .theme--dark & {
    .nx-tab {
      .v-tabs__item {
        opacity: 0.7;
        color: white;
        &--active {
          opacity: 1;
        }
      }
    }
  }
}
</style>
